"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));
var _ListItemIcon = _interopRequireDefault(require("@material-ui/core/ListItemIcon"));
var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));
var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));
var _KeyboardArrowDown = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowDown"));
var _KeyboardArrowUp = _interopRequireDefault(require("@material-ui/icons/KeyboardArrowUp"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Typography = _interopRequireDefault(require("../../Typography/Typography"));
var _excluded = ["dataMetrics", "expanded", "hasSubnav", "icon", "isChildSelected", "isFocused", "isSelected", "sidenavWidth", "text", "tabIndex", "tabRef"];
var useStyles = function useStyles(_ref) {
  var hasSubnav = _ref.hasSubnav,
    sidenavWidth = _ref.sidenavWidth,
    isFocused = _ref.isFocused;
  return (0, _makeStyles["default"])(function (theme) {
    var iconSize = 24;
    var fontSize = 14;
    var borderWidth = 2;
    return {
      arrowIcon: {
        '& svg': {
          height: iconSize,
          width: iconSize
        },
        color: theme.palette.common.white,
        left: sidenavWidth - theme.spacing(5),
        opacity: 0.7,
        position: 'absolute'
      },
      baseIconStyles: {
        '& svg': {
          height: iconSize,
          width: iconSize
        },
        color: theme.palette.common.white,
        marginRight: isFocused ? borderWidth + 1 : 1,
        minWidth: iconSize,
        paddingLeft: isFocused ? theme.spacing(2) - borderWidth : theme.spacing(2),
        paddingRight: isFocused ? theme.spacing(2) - borderWidth : theme.spacing(2)
      },
      baseTabStyles: {
        height: theme.spacing(7),
        paddingBottom: isFocused ? theme.spacing(2) - borderWidth : theme.spacing(2),
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: isFocused ? theme.spacing(2) - borderWidth : theme.spacing(2),
        whiteSpace: 'nowrap'
      },
      focusedTab: {
        '& $unselectedIcon, & $unselectedText, & $selectedIcon, & $selectedText, & $arrowIcon': {
          backgroundColor: theme.palette.opacity.secondary[14],
          color: theme.palette.common.white,
          opacity: 1
        },
        '&, &:focus-visible': {
          backgroundColor: theme.palette.opacity.white[14]
        },
        border: "2px solid ".concat(theme.palette.common.white)
      },
      listItemText: hasSubnav ? {
        flex: 'none'
      } : '',
      selectedIcon: {},
      selectedTab: {
        '&:hover': {
          backgroundColor: isFocused ? theme.palette.opacity.white[2] : theme.palette.secondary.dark
        },
        backgroundColor: isFocused ? theme.palette.opacity.white[2] : theme.palette.secondary.dark
      },
      selectedText: {
        color: theme.palette.common.white,
        fontSize: fontSize
      },
      unselectedIcon: {
        opacity: 0.7
      },
      unselectedTab: {
        '&:hover': {
          backgroundColor: isFocused ? theme.palette.opacity.white[14] : theme.palette.secondary.dark
        },
        '&:hover, &:hover $unselectedIcon, &:hover $unselectedText, &:hover) $arrowIcon': {
          backgroundColor: theme.palette.secondary.main,
          color: theme.palette.common.white,
          opacity: 1
        }
      },
      unselectedText: {
        color: theme.palette.common.white,
        fontSize: fontSize,
        opacity: 0.7
        // no hover styles defined here, see baseTabStyles
        // defining at the parent level activates desired text hover styles when any part of tab is hovered
      }
    };
  })();
};
var _ref2 = /*#__PURE__*/_react["default"].createElement(_KeyboardArrowUp["default"], null);
var _ref3 = /*#__PURE__*/_react["default"].createElement(_KeyboardArrowDown["default"], null);
var SidenavListItem = function SidenavListItem(props) {
  var _cx, _cx2, _cx3;
  var dataMetrics = props.dataMetrics,
    _props$expanded = props.expanded,
    expanded = _props$expanded === void 0 ? false : _props$expanded,
    hasSubnav = props.hasSubnav,
    icon = props.icon,
    isChildSelected = props.isChildSelected,
    isFocused = props.isFocused,
    isSelected = props.isSelected,
    sidenavWidth = props.sidenavWidth,
    text = props.text,
    tabIndex = props.tabIndex,
    tabRef = props.tabRef,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var classes = useStyles({
    hasSubnav: hasSubnav,
    isFocused: isFocused,
    sidenavWidth: sidenavWidth
  });
  return /*#__PURE__*/_react["default"].createElement(_ListItem["default"], (0, _extends2["default"])({
    "aria-expanded": hasSubnav ? expanded : undefined,
    button: true,
    className: (0, _classnames["default"])(classes.baseTabStyles, (_cx = {}, (0, _defineProperty2["default"])(_cx, classes.selectedTab, isSelected), (0, _defineProperty2["default"])(_cx, classes.unselectedTab, !isSelected), (0, _defineProperty2["default"])(_cx, classes.focusedTab, isFocused), _cx)),
    "data-metrics": dataMetrics,
    key: text,
    ref: tabRef,
    tabIndex: tabIndex === 0 ? 0 : -1
  }, rest), /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: (0, _classnames["default"])(classes.baseIconStyles, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, classes.selectedIcon, isSelected || isFocused || isChildSelected), (0, _defineProperty2["default"])(_cx2, classes.unselectedIcon, !isSelected && !isChildSelected), _cx2))
  }, icon), /*#__PURE__*/_react["default"].createElement(_ListItemText["default"], {
    className: classes.listItemText
  }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: (0, _classnames["default"])((_cx3 = {}, (0, _defineProperty2["default"])(_cx3, classes.selectedText, isSelected || isChildSelected), (0, _defineProperty2["default"])(_cx3, classes.unselectedText, !isSelected && !isChildSelected), _cx3))
  }, text)), hasSubnav && /*#__PURE__*/_react["default"].createElement(_ListItemIcon["default"], {
    className: classes.arrowIcon
  }, expanded ? _ref2 : _ref3));
};
SidenavListItem.propTypes = process.env.NODE_ENV !== "production" ? {
  dataMetrics: _propTypes["default"].string,
  expanded: _propTypes["default"].bool,
  hasSubnav: _propTypes["default"].bool,
  icon: _propTypes["default"].element.isRequired,
  isChildSelected: _propTypes["default"].bool,
  isFocused: _propTypes["default"].bool,
  isSelected: _propTypes["default"].bool,
  /**
   * Width of the Sidenav when expanded
   */
  sidenavWidth: _propTypes["default"].number,
  tabIndex: _propTypes["default"].number,
  tabRef: _propTypes["default"].object,
  text: _propTypes["default"].string.isRequired
} : {};
var _default = SidenavListItem;
exports["default"] = _default;